import Button from '@superfunnel/ui-core/v2/Button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@superfunnel/ui-core/v2/Tooltip';
import { classNames } from '../../utils';

interface SidebarSupportCardProps {
  collapsed?: boolean;
}

const SupportIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5 shrink-0"
  >
    <g clipPath="url(#clip0_support)">
      <path
        d="M7.50008 7.50033C7.50008 4.58364 12.0834 4.58366 12.0834 7.50033C12.0834 9.58366 10.0001 9.16694 10.0001 11.6669M10.0001 15.0087L10.0084 14.9994M18.3334 10.0003C18.3334 14.6027 14.6025 18.3337 10.0001 18.3337C8.48222 18.3337 7.05914 17.9279 5.83341 17.2188L2.08341 17.917L2.7816 14.167C2.07256 12.9413 1.66675 11.5182 1.66675 10.0003C1.66675 5.39795 5.39771 1.66699 10.0001 1.66699C14.6025 1.66699 18.3334 5.39795 18.3334 10.0003Z"
        stroke="#141C25"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_support">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SUPPORT_CALENDAR_URL = 'https://calendly.com/superfunnelai/support';

export default function SidebarSupportCard({
  collapsed,
}: SidebarSupportCardProps) {
  const handleScheduleClick = () => {
    window.open(SUPPORT_CALENDAR_URL, '_blank', 'noopener,noreferrer');
  };

  const card = (
    <div
      className={classNames(
        'flex flex-col items-start justify-start overflow-hidden rounded-2xl bg-gray-50 duration-300 ease-in-out',
        collapsed
          ? 'h-10 w-10 cursor-pointer p-2.5 hover:bg-gray-200'
          : 'w-full gap-3 p-4',
      )}
      onClick={collapsed ? handleScheduleClick : undefined}
      title={collapsed ? 'Schedule Support Session' : undefined}
    >
      <div
        className={classNames(
          'flex flex-col items-start justify-start gap-2 overflow-hidden text-start whitespace-nowrap duration-300 ease-in-out',
          collapsed ? 'h-0 gap-0 opacity-0' : 'opacity-100',
        )}
      >
        <div className="flex items-center justify-start gap-2.5">
          <SupportIcon />
          <p className="text-base font-semibold text-[#141c25]">Need Support</p>
        </div>
        <p className="text-sm text-[#414e62]">
          Set up a call with our support
          <br />
          team.
        </p>
      </div>
      {collapsed && (
        <div className="flex h-5 w-5 items-center justify-center">
          <SupportIcon />
        </div>
      )}
      {!collapsed && (
        <Button
          // color="primary"
          variant={'outline'}
          onClick={!collapsed ? handleScheduleClick : undefined}
          className={classNames(
            // 'bg-black hover:bg-gray-800',
            'whitespace-nowrap',
            collapsed
              ? 'h-0 w-0 overflow-hidden p-0 opacity-0'
              : 'w-full opacity-100',
          )}
          tabIndex={collapsed ? -1 : 0}
        >
          Schedule Session
        </Button>
      )}
    </div>
  );

  if (!collapsed) {
    return card;
  }

  return (
    <Tooltip>
      <TooltipTrigger disabled={!collapsed} asChild>
        {card}
      </TooltipTrigger>
      <TooltipContent side="right">Schedule a support session</TooltipContent>
    </Tooltip>
  );
}
